/**
 * (c) Les Affranchis - 2009-2021
 *
 * Author - Martin Tremblay - martin@lesaffranchis.ca
 */

import Bus from "Shared/Bus.js";

function onReady ()
{
    console.log("%cVIMY", "background-color: orange");
}


let strConsoleColor = "background-color:#000099; color:white;";

console.log("%cVimy : Living Memorial Vivant",strConsoleColor)
console.log("%cCompilation date: " + __COMPILATION_DATE__, strConsoleColor)
document.addEventListener('DOMContentLoaded', onReady);

